// extracted by mini-css-extract-plugin
export var chip = "_ev-0";
export var filterDropdown = "_ev-5";
export var filterItem = "_ev-6";
export var icon = "_ev-1";
export var removeButton = "_ev-3";
export var removeIcon = "_ev-4";
export var separator = "_ev-2";